<template>
  <div id="app">
    <NotificationContainer />
    <AppLoading v-if="loader.blockingLoader" />
    <!--    <transition name="slide-fade" mode="in-out">-->
    <router-view :key="$route.fullPath" />
    <!--    </transition>-->

    <portal-target name="modals-container" multiple />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NotificationContainer from "./components/utility/Notification/NotificationContainer";
import AppLoading from "./components/app/AppLoading";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "app",
  components: {
    NotificationContainer,
    AppLoading
  },
  computed: {
    ...mapState(["loader"])
  },
  mounted() {
    // StoreUtils.dispatch(StoreUtils.actions.auth.TIMESLOT_LOGIN);
  }
};
</script>

<style lang="scss">
@import "./styles/main.scss";

a {
  cursor: pointer;
}

#app {
  font-family: "Galano grotesque-Regular", sans-serif;
}

.slide-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-enter-to {
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave {
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

@font-face {
  font-family: "Galano grotesque-Regular";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque.otf") format("opentype");
}

@font-face {
  font-family: "Galano grotesque-Light";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque-Light.otf")
      format("opentype");
}

@font-face {
  font-family: "Galano grotesque-Medium";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque-Medium.otf")
      format("opentype");
}

@font-face {
  font-family: "Galano grotesque-Bold";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque-Bold.otf")
      format("opentype");
}

@font-face {
  font-family: "Galano grotesque-Thin";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque-Thin.otf")
      format("opentype");
}

@font-face {
  font-family: "Galano grotesque-SemiBold";
  src: local("Galano grotesque"),
    url("././assets/timeslot-fonts/Galano-Grotesque-Semi-Bold.otf")
      format("opentype");
}

@font-face {
  font-family: "GT-Light";
  src: local("GTEestiProDisplay"),
    url("fonts/GTEestiProDisplay/GTEestiProDisplay-Light.woff") format("woff");
}

@font-face {
  font-family: "GT-Medium";
  src: local("GTEestiProDisplay"),
    url("fonts/GTEestiProDisplay/GTEestiProDisplay-Medium.woff") format("woff");
}

@font-face {
  font-family: "GT-Regular";
  src: local("GTEestiProDisplay"),
    url("fonts/GTEestiProDisplay/GTEestiProDisplay-Regular.woff") format("woff");
}

@font-face {
  font-family: "GT-Thin";
  src: local("GTEestiProDisplay"),
    url("fonts/GTEestiProDisplay/GTEestiProDisplay-Thin.woff") format("woff");
}

@font-face {
  font-family: "GT-Regular-Italic";
  src: local("GTEestiProDisplay"),
    url("fonts/GTEestiProDisplay/GTEestiProDisplay-RegularItalic.woff2")
      format("woff2");
}
</style>
